import { XMarkIcon } from '@heroicons/react/16/solid';
import React, { useEffect } from 'react';
import { Modal } from 'react-daisyui';
import { useTranslation } from 'react-i18next';
import { useModalsContext } from '../../../../../../providers/ModalsProvider/Modals.context.ts';
import { useSyncConversationsContext } from '../../../../../../providers/SyncConversationsProvider/SyncConversations.context.tsx';
import { SyncConversationsEnum } from '../../../../../../providers/SyncConversationsProvider/SyncConversations.enum.ts';
import './SyncConversationsSyncing.styles.scss';

const tipsCycle = 3;

export default function SyncConversationsSyncing() {
  const { t } = useTranslation('dashboard/dashboard');

  const tips = [
    t('components.modals.SyncConversations.syncing.tip1'),
    t('components.modals.SyncConversations.syncing.tip2'),
    t('components.modals.SyncConversations.syncing.tip3'),
  ];

  const { syncConversationsStatus, setSyncConversationsStatus } =
    useModalsContext();

  const { syncConversations, totalConversations, initialProgress } =
    useSyncConversationsContext();

  const [carrouselIndex, setCarrouselIndex] = React.useState(1);

  const calculatePercentage = () => {
    return (syncConversations / totalConversations) * 100;
  };

  useEffect(() => {
    if (syncConversations >= totalConversations) {
      setSyncConversationsStatus(SyncConversationsEnum.SUCCESS);
    }
  }, [syncConversations]);

  useEffect(() => {
    const changeAfterTime = () => {
      setTimeout(() => {
        if (carrouselIndex === tipsCycle) {
          setCarrouselIndex(1);
        } else {
          setCarrouselIndex(carrouselIndex + 1);
        }
      }, 5000);
    };
    changeAfterTime();
  }, [carrouselIndex]);

  const bodyTitle =
    initialProgress >= 100
      ? t('components.modals.SyncConversations.syncing.syncingConversations')
      : t('components.modals.SyncConversations.syncing.syncingContacts');

  return (
    <Modal
      className="SyncConversationsSyncing w-full max-w-4xl"
      open={syncConversationsStatus === SyncConversationsEnum.SYNCING}
    >
      <div className="SyncConversationsSyncing__Close">
        <XMarkIcon
          className="SyncConversationsSyncing__Close__Icon"
          onClick={() =>
            setSyncConversationsStatus(SyncConversationsEnum.PROGRESS_TOASTER)
          }
        />
      </div>
      <div className="SyncConversationsSyncing__Container">
        <div className="SyncConversationsSyncing__Body">
          <img
            src={`/images/sync/syncMobileSyncing-${carrouselIndex}.png`}
            alt={`syncMobileSyncing-${carrouselIndex}.png`}
            className="SyncConversationsSyncing__Body__Image"
          />
          <p className="SyncConversationsSyncing__Body__Text">
            {tips[carrouselIndex - 1]}
          </p>
          <div className="SyncConversationsSyncing__Body__Circle">
            {Array.from({ length: tipsCycle }).map((_, index) => (
              <button
                onClick={() => {
                  setCarrouselIndex(index + 1);
                }}
                key={index}
                className={`SyncConversationsSyncing__Body__Circle__Dot ${index + 1 === carrouselIndex ? 'bg-primary' : 'bg-neutral'}`}
              ></button>
            ))}
          </div>

          <p className="SyncConversationsSyncing__Body__Title">{bodyTitle}</p>

          <div className="SyncConversationsSyncing__Body__Progress">
            {initialProgress < 100 && (
              <div className="SyncConversationsSyncing__Body__Progress__Text">
                {initialProgress} %
              </div>
            )}
            <div className="SyncConversationsSyncing__Body__Progress__BarContainer">
              <div
                className="SyncConversationsSyncing__Body__Progress__BarContainer__Bar"
                style={{
                  width: `${initialProgress >= 100 ? calculatePercentage() : initialProgress}%`,
                }}
              ></div>
            </div>
          </div>
          {initialProgress >= 100 ? (
            <p className="SyncConversationsSyncing__Body__Progress__Done">
              {syncConversations}/{totalConversations}
            </p>
          ) : null}
        </div>
      </div>
    </Modal>
  );
}
